import { useState } from 'react';
import { usePolarisEvents } from './polaris';

type ThumbnailSize = 'extraSmall' | 'small' | 'medium' | 'large';

const sizes = {
    extraSmall: 'small-200',
    small: 'small',
    medium: 'base',
    large: 'large',
} as const;

type ProductThumbnailProps = { source?: string | null; alt: string; size?: ThumbnailSize };

export default function ProductThumbnail({ source, alt, size = 'medium' }: ProductThumbnailProps) {
    const [failedSource, setFailedSource] = useState<string>();
    const imageSource = source?.trim();
    const showImage = !!imageSource && imageSource !== failedSource;
    const events = usePolarisEvents({ error: () => setFailedSource(imageSource) });

    // Without a src, s-thumbnail renders Shopify's standard image placeholder.
    return (
        <s-thumbnail
            ref={events}
            src={showImage ? imageSource : undefined}
            alt={showImage ? alt : `No image available for ${alt}`}
            size={sizes[size]}
        />
    );
}
